<ion-header mode="md">
	<ion-toolbar color="primary" mode="md">
		<ion-buttons slot="start">
			<ion-button (click)="dismiss()">
				<ion-icon name="arrow-back-outline"></ion-icon>
			</ion-button>
		</ion-buttons>
		<ion-title mode="md">
			<div class="simple-modal-header-title">{{ pageTitle }}</div>
		</ion-title>

		<ng-content select="[slot='end']"></ng-content>
	</ion-toolbar>

	<ng-content></ng-content>
</ion-header>
